import React, { useEffect, useState, useCallback } from "react";

import { useHistory, useLocation, useParams } from "react-router";
import Swal from "sweetalert2";
import { format, intervalToDuration } from "date-fns";
import love from "../../../../assets/images/love_no_bg.png";

import {
  Flex,
  Box,
  Image,
  Text,
  Button,
  Spacer,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem as ItemMenu,
  Grid,
  GridItem,
  Link,
  useDisclosure,
} from "@chakra-ui/react";

import { HiOutlineClipboardList } from "react-icons/hi";
import { TbGavel } from "react-icons/tb";
import { RiErrorWarningLine, RiSuitcaseLine } from "react-icons/ri";
import { MdOutlineFilePresent } from "react-icons/md";
import { IoDocumentsOutline } from "react-icons/io5";
import { FaArrowsDownToPeople } from "react-icons/fa6";
import { GiFamilyTree } from "react-icons/gi";
import { FiFileText } from "react-icons/fi";
import { HamburgerIcon } from "@chakra-ui/icons";
import { GrDocumentTime } from "react-icons/gr";

import { checkEntity } from "../../../components/router/PageData/data";
import Information from "../../ServicosAcolhimento/PanelBase/Information";
import MenuItem from "./MenuItem";
import LoadingSpinner from "../../../components/LoadingSpinner";

import CriancaService from "../../../../main/services/CriancaService";
import DocumentacaoService from "../../../../main/services/DocumentacaoService";
import MovimentacaoService from "../../../../main/services/MovimentacaoService";
import { BsHeartPulse } from "react-icons/bs";
import { PiBookBookmarkBold } from "react-icons/pi";
import {
  Permission,
  criancaFunc,
  ocorrenciasFunc,
  referenciaFunc,
  servicoAcolhimentoFunc,
  vrCriancaFunc,
} from "../../../../helpers/Funcionalidades";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { PrintButtonCrianca } from "../../../components/PrintButtonCrianca";
import ServicoPreviewModal from "../../../components/ServicoPreviewModal";

export const PanelBase = ({ children, loadingPainel, setDataNascimento }) => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();

  const [imagem, setImagem] = useState("");
  const [pagina, setPagina] = useState("");
  const [data, setData] = useState();
  const [pendentes, setPendentes] = useState();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const diferencaAnos = data?.dataNascimento
    ? intervalToDuration({
        start: new Date(data?.dataNascimento),
        end: new Date(),
      }).years
    : "";

  const [documentacao, setDocumentacao] = useState();
  const { roleKeycloack, user } = useAuthProvider();
  const {
    setUltimaMovimentacao,
    setPrimeiraMovimentacao,
    editarCriancaCr,
    setEditarCriancaCr,
    editarDocCrianca,
    setEditarDocCrianca,
    cadastrarDocCrianca,
    cadastrarSaudeCrianca,
    setCadastrarDocCrianca,
    setCadastrarSaudeCrianca,
    editarSaudeCrianca,
    setEditarSaudeCrianca,
    cadastrarProfCrianca,
    setCadastrarProfCrianca,
    editarProfCrianca,
    setEditarProfCrianca,
    cadastrarEducCrianca,
    setCadastrarEducCrianca,
    editarEducCrianca,
    setEditarEducCrianca,
    cadastrarOcorCrianca,
    setCadastrarOcorCrianca,
    editarOcorCrianca,
    setEditarOcorCrianca,
    setFiliacao,
    setSituacaoMovimento,
    setPossuiOcorrencia,
    setHouveExtincaoPoderFamiliar,
    editarAnexoCrianca,
    setEditarAnexoCrianca,
    anexarCrianca,
    setAnexarCrianca,
    setIdPJ,
    idPJ,
    cadastrarApadrinhamentoCrianca,
    editarApadrinhamentoCrianca,
    setCadastrarApadrinhamentoCrianca,
    setEditarApadrinhamentoCrianca,
    setMovimentacoesPendente,
  } = useAppContext();
  const origem = new URLSearchParams(location.search).get("origem");
  const servicoId = new URLSearchParams(location.search).get("servicoId");

  const permissaoServico =
    roleKeycloack.includes(criancaFunc.visualizarTudo) ||
    roleKeycloack.includes(servicoAcolhimentoFunc.visualizarPartePPCAAM) ||
    roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
    roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
    ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
      roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
      user?.orgaoExterno?.includes(data?.servicoAcolhimento?.idPessoaJuridica));

  const [temRiscoVidaInfo, setTemRiscoVidaInfo] = useState(false);

  function LoveIcon() {
    return (
      <Box
        boxSize="20px"
        backgroundImage={`url(${love})`}
        backgroundSize="contain"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
      />
    );
  }

  const getPendentes = useCallback(() => {
    CriancaService.listarPendentes(id)
      .then((res) => {
        let tempObj = {};
        res.data.forEach((item) => {
          const tempItem = item.split(":");
          tempObj[tempItem[0]] = Number(tempItem[1]);
        });
        setPendentes(tempObj);
        setPossuiOcorrencia(tempObj.ocorrencias === 0 ? true : false);
      })
      .catch((error) => console.log(error));
  }, [id, setPossuiOcorrencia]);

  const getDataCrianca = useCallback(() => {
    CriancaService.getCrianca(id)
      .then((res) => {
        setData(res.data);
        setFiliacao(res.data.filiacoes);
        setPrimeiraMovimentacao(res?.data?.movimentacoes[0]?.dataMovimentacao);
        setMovimentacoesPendente(
          res?.data?.movimentacoes?.some(
            (mov) => mov?.movimentoMovimentacao?.id === 5
          )
        );
        setHouveExtincaoPoderFamiliar(res.data.houveExtincaoPoderFamiliar);
        setIdPJ(res.data?.servicoAcolhimento?.idPessoaJuridica);

        const anexos = res.data.anexos.filter(
          (item) => item.categoriaAnexo.id === 1
        );

        anexos.sort((a, b) => new Date(b.dataUpload) - new Date(a.dataUpload));

        CriancaService.getAnexo(res.data.idAnexoFoto, "visualizar")
          .then((res) => {
            setImagem(res.config.url);
          })
          .catch((error) => {
            setImagem("");
            console.log(error);
          });
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 404) {
            if (err.response.data) {
              Swal.fire({
                title: "Atenção!",
                text: err.response.data.message
                  ? err.response.data.message
                  : "Registro não encontrado",
                icon: "warning",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              }).then(() => {
                history.push("/crianca");
              });
            }
          }
        }
      });
  }, [
    id,
    history,
    setFiliacao,
    setIdPJ,
    setHouveExtincaoPoderFamiliar,
    setMovimentacoesPendente,
  ]);

  useEffect(() => {
    CriancaService.getCrianca(id)
      .then((res) => {
        sessionStorage.setItem("crianca-passou", true);
        setFiliacao(res.data.filiacoes);

        setMovimentacoesPendente(
          res?.data?.movimentacoes?.some(
            (mov) => mov?.movimentoMovimentacao?.id === 5
          )
        );

        setHouveExtincaoPoderFamiliar(res.data.houveExtincaoPoderFamiliar);

        let primeiraMovimentacaoGet;

        let temRiscoVida = false;
        if (res.data.movimentacoes && res.data.movimentacoes.length > 0) {
          const movimentacoesComData = res.data.movimentacoes.filter(
            (item) => item.ordem
          );

          if (movimentacoesComData.length > 0) {
            movimentacoesComData.sort((a, b) => b.ordem - a.ordem);

            primeiraMovimentacaoGet = movimentacoesComData[0];

            if (
              primeiraMovimentacaoGet?.movimentoMovimentacao?.id === 1 ||
              primeiraMovimentacaoGet?.movimentoMovimentacao?.id === 6
            ) {
              const movimentacoes = movimentacoesComData || [];

              for (const mov of movimentacoes) {
                if (
                  mov?.movimentoMovimentacao?.id === 3 ||
                  !mov?.movimentoMovimentacao?.id
                ) {
                  temRiscoVida = mov?.motivoSituacao?.riscoVida === "S";
                  setTemRiscoVidaInfo(mov?.motivoSituacao?.riscoVida === "S");
                  break;
                }
              }
            }

            setSituacaoMovimento(movimentacoesComData[0]);
          }
        }

        if (
          (temRiscoVida ||
            primeiraMovimentacaoGet?.motivoSituacao?.riscoVida === "S") &&
          roleKeycloack &&
          roleKeycloack.length > 0 &&
          !roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
          !(
            (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
              roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              res.data?.servicoAcolhimento?.idPessoaJuridica
            )
          )
        ) {
          Swal.fire({
            title: "Atenção!",
            text: "Por favor, entre em contato com o Gestor do MCA.",
            icon: "warning",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          }).then((result) => {
            if (result.isConfirmed) {
              history.push("/crianca");
            } else {
              history.push("/crianca");
            }
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 404) {
            if (err.response.data) {
              Swal.fire({
                title: "Atenção!",
                text: err.response.data.message
                  ? err.response.data.message
                  : "Registro não encontrado",
                icon: "warning",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              }).then(() => {
                history.push("/crianca");
              });
            }
          }
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    history,
    id,
    roleKeycloack,
    setFiliacao,
    setHouveExtincaoPoderFamiliar,
    setMovimentacoesPendente,
    setSituacaoMovimento,
  ]);

  useEffect(() => {
    getDataCrianca();

    DocumentacaoService.getDocumentacao(id)
      .then((res) => {
        setDocumentacao(res.data);
      })
      .catch((erro) => {});

    getPendentes();
  }, [loadingPainel, id, getDataCrianca, getPendentes]);

  useEffect(() => {
    MovimentacaoService.getMovimentacoes(id).then((res) => {
      setPrimeiraMovimentacao(res.data[0]?.dataMovimentacao);
      setSituacaoMovimento(res.data[res.data.length - 1]);
      setUltimaMovimentacao(res.data[res.data.length - 1]);
    });
  }, [
    id,
    setPrimeiraMovimentacao,
    setSituacaoMovimento,
    setUltimaMovimentacao,
  ]);

  useEffect(() => {
    if (setDataNascimento) {
      const getDataCriancaData = () => {
        CriancaService.getCrianca(id)
          .then((res) => {
            setDataNascimento(res.data.dataNascimento);
            setFiliacao(res.data.filiacoes);
          })
          .catch((err) => {
            console.log(err);
          });
      };
      getDataCriancaData();
    }
  }, [id, setDataNascimento, setFiliacao]);

  useEffect(() => {
    const urlAarry = location.pathname.split("/");
    const tempPage = checkEntity(urlAarry[1], urlAarry[2]).page;
    setPagina(tempPage);
    if (tempPage.includes("Visualizar Documentacao")) {
      DocumentacaoService.getDocumentacao(id)
        .then((res) => {
          setDocumentacao(res.data);
        })
        .catch((erro) => {});
    }
    if (tempPage.includes("Visualizar")) {
      getPendentes();
      getDataCrianca();
    }
  }, [location, loadingPainel, id, getDataCrianca, getPendentes]);

  const backAlert = (rota) => {
    if (
      editarCriancaCr ||
      editarDocCrianca ||
      cadastrarDocCrianca ||
      cadastrarSaudeCrianca ||
      cadastrarApadrinhamentoCrianca ||
      editarApadrinhamentoCrianca ||
      editarSaudeCrianca ||
      cadastrarProfCrianca ||
      editarProfCrianca ||
      cadastrarEducCrianca ||
      editarEducCrianca ||
      cadastrarOcorCrianca ||
      editarOcorCrianca ||
      anexarCrianca ||
      editarAnexoCrianca
    ) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push(rota);
          setEditarCriancaCr(false);
          setEditarDocCrianca(false);
          setCadastrarDocCrianca(false);
          setCadastrarSaudeCrianca(false);
          setCadastrarApadrinhamentoCrianca(false);
          setEditarSaudeCrianca(false);
          setEditarApadrinhamentoCrianca(false);
          setCadastrarProfCrianca(false);
          setEditarProfCrianca(false);
          setCadastrarEducCrianca(false);
          setEditarEducCrianca(false);
          setCadastrarOcorCrianca(false);
          setEditarOcorCrianca(false);
          setAnexarCrianca(false);
          setEditarAnexoCrianca(false);
        }
      });
    } else {
      history.goBack();
    }
  };

  const handleMenuItemClick = (rota) => {
    if (
      ((pagina.includes("Cadastrar") ||
        pagina.includes("documentacao") ||
        pagina.includes("Saude") ||
        pagina.includes("Profissionalizacao") ||
        pagina.includes("Educacao") ||
        pagina.includes("Ocorrencias") ||
        pagina.includes("anexos")) &&
        (cadastrarDocCrianca ||
          cadastrarSaudeCrianca ||
          cadastrarApadrinhamentoCrianca ||
          cadastrarProfCrianca ||
          cadastrarEducCrianca ||
          cadastrarOcorCrianca ||
          anexarCrianca)) ||
      ((pagina.includes("Editar") ||
        pagina.includes("documentacao") ||
        pagina.includes("Saude") ||
        pagina.includes("Profissionalizacao") ||
        pagina.includes("Educacao") ||
        pagina.includes("Ocorrencias") ||
        pagina.includes("anexos")) &&
        (editarCriancaCr ||
          editarDocCrianca ||
          editarSaudeCrianca ||
          editarApadrinhamentoCrianca ||
          editarProfCrianca ||
          editarEducCrianca ||
          editarOcorCrianca ||
          editarAnexoCrianca))
    ) {
      backAlert(rota);
    } else {
      history.push(rota);
    }
  };

  const handlePageName = () => {
    let tempName = "";
    switch (pagina) {
      case "Cadastrar Documentacao":
        tempName = "Cadastrar Documentação";
        break;
      case "Editar Documentacao":
        tempName = "Editar Documentação";
        break;
      case "Visualizar Documentacao":
        tempName = "Visualizar Documentação";
        break;
      case "Cadastrar Anexos":
        tempName = "Anexar Documentos";
        break;
      case "Cadastrar Movimentacao":
        tempName = "Cadastrar Movimentação";
        break;
      case "Editar Movimentacao":
        tempName = "Editar Movimentação";
        break;
      case "Visualizar Movimentacao":
        tempName = "Visualizar Movimentação";
        break;
      case "Cadastrar Ocorrencias":
        tempName = "Cadastrar Ocorrências";
        break;
      case "Editar Ocorrencias":
        tempName = "Editar Ocorrências";
        break;
      case "Visualizar Ocorrencias":
        tempName = "Visualizar Ocorrências";
        break;
      case "Editar Educacao":
        tempName = "Editar Educação";
        break;
      case "Visualizar Educacao":
        tempName = "Visualizar Educação";
        break;
      case "Editar Profissionalizacao":
        tempName = "Editar Profissionalização";
        break;
      case "Visualizar Profissionalizacao":
        tempName = "Visualizar Profissionalização";
        break;
      case "Editar Saude":
        tempName = "Editar Saúde";
        break;
      case "Visualizar Saude":
        tempName = "Visualizar Saúde";
        break;
      case "Visualizar Referencia Familiar":
        tempName = "Visualizar Referência Familiar";
        break;
      case "Visualizar Situacao Juridica":
        tempName = "Visualizar Situação Jurídica";
        break;
      case "Visualizar Apadrinhamento":
        tempName = "Visualizar Programa de Apadrinhamento";
        break;
      case "Cadastrar Apadrinhamento":
        tempName = "Cadastrar Programa de Apadrinhamento";
        break;
      case "Editar Apadrinhamento":
        tempName = "Editar Programa de Apadrinhamento";
        break;
      default:
        tempName = pagina;
        break;
    }
    return tempName;
  };

  let primeiraMovimentacao;

  if (data?.movimentacoes && data?.movimentacoes.length > 0) {
    const movimentacoesComData = data.movimentacoes.filter(
      (item) => item.ordem
    );

    if (movimentacoesComData.length > 0) {
      movimentacoesComData.sort((a, b) => b.ordem - a.ordem);

      primeiraMovimentacao = movimentacoesComData[0];
    }
  }

  const visualizarDados =
    ((primeiraMovimentacao?.motivoSituacao?.tipoSituacao?.descricao ===
      "Acolhido" ||
      !primeiraMovimentacao?.motivoSituacao?.tipoSituacao?.descricao) &&
      (roleKeycloack?.includes(criancaFunc.visualizarAcolhido) ||
        ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
          user?.orgaoExterno?.includes(idPJ)))) ||
    (primeiraMovimentacao?.motivoSituacao?.tipoSituacao?.descricao ===
      "Desligado" &&
      roleKeycloack &&
      !roleKeycloack.includes(criancaFunc.visualizarTudoTutelar) &&
      !roleKeycloack.includes(criancaFunc.visualizarTudoDefensoria) &&
      !roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento));

  return (
    <Flex
      flex={1}
      flexDir="column"
      px={{ base: "10px", xl: "24px", "2xl": "32px" }}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <Flex
        pt="4px"
        flexDir="row"
        justifyContent="space-between"
        alignItems="center"
        w="100%"
      >
        <Text
          color="#252733"
          fontWeight={700}
          fontSize="24px"
          lineHeight="29.05px"
        >
          {pagina === "Visualizar"
            ? "Visualizar Dados Principais"
            : handlePageName()}
        </Text>
        <Button
          color="#FFF"
          backgroundColor="#169499"
          fontWeight={700}
          fontSize="15px"
          lineHeight="21.6px"
          _hover={{ bg: "#169499" }}
          onClick={() => {
            if (pagina.includes("Cadastrar") || pagina.includes("Editar")) {
              if (
                pagina.includes("Ocorrencias") ||
                pagina.includes("Documentacao")
              ) {
                history.push("/crianca");
              } else {
                backAlert(`/crianca/${id}`);
              }
            } else {
              if (origem && servicoId && origem === "familia-acolhedora") {
                history.push(
                  `/servico-acolhimento/visualizar-familia-acolhedora/${servicoId}`
                );
              } else {
                history.push("/crianca");
              }
            }
          }}
          w="84px"
        >
          Voltar
        </Button>
      </Flex>

      <Flex flexDir={{ base: "column", xl: "row" }} mt="20px" w="100%">
        {/*Menu responsivo*/}
        <Flex
          zIndex={"10"}
          display={{ base: "block", xl: "none" }}
          textAlign="right"
          marginBottom="4%"
        >
          <Menu align="center" autoSelect={false}>
            <MenuButton
              as={Button}
              aria-label="Options"
              icon={<HamburgerIcon />}
              variant="solid"
              colorScheme="teal"
              color="#FFF"
              backgroundColor="#169499"
            >
              Menu <HamburgerIcon />
            </MenuButton>
            <MenuList>
              <ItemMenu
                height="40px"
                icon={<Icon boxSize="20px" as={HiOutlineClipboardList} />}
                onClick={() => handleMenuItemClick("/crianca/" + id)}
              >
                Dados Principais
              </ItemMenu>
              {visualizarDados ? (
                <>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={vrCriancaFunc.documentacaoVisualizar}
                    id={idPJ}
                    user={user}
                    visualizar={true}
                  >
                    <ItemMenu
                      height="40px"
                      icon={<Icon boxSize="20px" as={IoDocumentsOutline} />}
                      onClick={() =>
                        handleMenuItemClick(
                          "/crianca/visualizar-documentacao/" + id
                        )
                      }
                    >
                      <Flex>
                        <Text>Documentação</Text>
                        <Spacer />
                        {(pendentes ? pendentes.documentacao === 0 : false) && (
                          <Icon
                            aria-label="Aviso de pendente"
                            color="#D80000"
                            as={RiErrorWarningLine}
                            boxSize="20px"
                          />
                        )}
                      </Flex>
                    </ItemMenu>
                  </Permission>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={vrCriancaFunc.movimentoVisualizar}
                    id={idPJ}
                    user={user}
                    visualizar={true}
                  >
                    <ItemMenu
                      height="40px"
                      icon={<Icon boxSize="20px" as={GrDocumentTime} />}
                      onClick={() =>
                        handleMenuItemClick(
                          "/crianca/visualizar-movimentacao/" + id
                        )
                      }
                    >
                      <Flex>
                        <Text>Histórico</Text>
                        <Spacer />
                        {(pendentes ? pendentes.movimentacao === 0 : false) && (
                          <Icon
                            aria-label="Aviso de pendente"
                            color="#D80000"
                            as={RiErrorWarningLine}
                            boxSize="20px"
                          />
                        )}
                      </Flex>
                    </ItemMenu>
                  </Permission>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={referenciaFunc.referenciaVisualizar}
                    id={idPJ}
                    user={user}
                    visualizar={true}
                  >
                    <ItemMenu
                      height="40px"
                      icon={
                        <Icon
                          boxSize="20px"
                          style={{ transform: "rotate(180deg)" }}
                          as={GiFamilyTree}
                        />
                      }
                      onClick={() =>
                        handleMenuItemClick(
                          "/crianca/visualizar-referencia-familiar/" + id
                        )
                      }
                    >
                      <Flex>
                        <Text>Referência Familiar</Text>
                        <Spacer />
                        {(pendentes
                          ? pendentes.grupoFraterno === 0
                          : false) && (
                          <Icon
                            aria-label="Aviso de pendente"
                            color="#D80000"
                            as={RiErrorWarningLine}
                            boxSize="20px"
                          />
                        )}
                      </Flex>
                    </ItemMenu>
                  </Permission>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={criancaFunc.visualizarSaude}
                    id={idPJ}
                    user={user}
                    visualizar={true}
                  >
                    <ItemMenu
                      height="40px"
                      icon={<Icon boxSize="20px" as={BsHeartPulse} />}
                      onClick={() =>
                        handleMenuItemClick("/crianca/visualizar-saude/" + id)
                      }
                    >
                      <Flex>
                        <Text>Saúde</Text>
                        <Spacer />
                        {(pendentes ? pendentes.saude === 0 : false) && (
                          <Icon
                            aria-label="Aviso de pendente"
                            color="#D80000"
                            as={RiErrorWarningLine}
                            boxSize="20px"
                          />
                        )}
                      </Flex>
                    </ItemMenu>
                  </Permission>

                  <ItemMenu
                    height="40px"
                    icon={<Icon boxSize="20px" as={PiBookBookmarkBold} />}
                    onClick={() =>
                      handleMenuItemClick("/crianca/visualizar-educacao/" + id)
                    }
                  >
                    <Flex>
                      <Text>Educação</Text>
                      <Spacer />
                      {(pendentes ? pendentes.educacao === 0 : false) && (
                        <Icon
                          aria-label="Aviso de pendente"
                          color="#D80000"
                          as={RiErrorWarningLine}
                          boxSize="20px"
                        />
                      )}
                    </Flex>
                  </ItemMenu>

                  {diferencaAnos >= 16 && (
                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={criancaFunc.visualizarProfissionalizacao}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <ItemMenu
                        height="40px"
                        icon={<Icon boxSize="20px" as={RiSuitcaseLine} />}
                        onClick={() =>
                          handleMenuItemClick(
                            "/crianca/visualizar-profissionalizacao/" + id
                          )
                        }
                      >
                        <Flex>
                          <Text>Profissionalização</Text>
                          {(pendentes
                            ? pendentes.profissionalizacao === 0
                            : false) && (
                            <Icon
                              aria-label="Aviso de pendente"
                              color="#D80000"
                              as={RiErrorWarningLine}
                              boxSize="20px"
                            />
                          )}
                        </Flex>
                      </ItemMenu>
                    </Permission>
                  )}

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={ocorrenciasFunc.visualizar}
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    <ItemMenu
                      height="40px"
                      icon={<Icon boxSize="20px" as={FiFileText} />}
                      onClick={() =>
                        handleMenuItemClick(
                          "/crianca/visualizar-ocorrencias/" + id
                        )
                      }
                    >
                      <Flex>
                        <Text>Ocorrências</Text>
                        <Spacer />
                        {(pendentes ? pendentes.ocorrencias === 0 : false) && (
                          <Icon
                            aria-label="Aviso de pendente"
                            color="#D80000"
                            as={RiErrorWarningLine}
                            boxSize="20px"
                          />
                        )}
                      </Flex>
                    </ItemMenu>
                  </Permission>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={vrCriancaFunc.visitaCriancaVisualizar}
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    <ItemMenu
                      height="40px"
                      icon={<Icon boxSize="20px" as={FaArrowsDownToPeople} />}
                      onClick={() => {
                        handleMenuItemClick(
                          "/crianca/visualizar-visitas/" + id
                        );
                      }}
                    >
                      <Flex>
                        <Text>Visitas</Text>
                        <Spacer />
                        {(pendentes ? pendentes.visita === 0 : false) && (
                          <Icon
                            aria-label="Aviso de pendente"
                            color="#D80000"
                            as={RiErrorWarningLine}
                            boxSize="20px"
                          />
                        )}
                      </Flex>
                    </ItemMenu>
                  </Permission>
                  <ItemMenu
                    height="40px"
                    icon={<Icon boxSize="20px" as={TbGavel} />}
                    onClick={() => {
                      handleMenuItemClick(
                        "/crianca/visualizar-situacao-juridica/" + id
                      );
                    }}
                  >
                    <Flex>
                      <Text>Situação Jurídica</Text>
                      <Spacer />
                      {(pendentes
                        ? pendentes.situacaoJuridica === 0
                        : false) && (
                        <Icon
                          aria-label="Aviso de pendente"
                          color="#D80000"
                          as={RiErrorWarningLine}
                          boxSize="20px"
                        />
                      )}
                    </Flex>
                  </ItemMenu>

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={criancaFunc.apadrinhamentoVisualizar}
                    id={idPJ}
                    user={user}
                    visualizar={true}
                  >
                    <ItemMenu
                      height="40px"
                      icon={<Icon boxSize="20px" as={BsHeartPulse} />}
                      onClick={() =>
                        handleMenuItemClick(
                          "/crianca/visualizar-apadrinhamento/" + id
                        )
                      }
                    >
                      <Flex>
                        <Text>Programa de Apadrinhamento</Text>
                        <Spacer />
                        {(pendentes
                          ? pendentes?.apadrinhamento === 0
                          : false) && (
                          <Icon
                            aria-label="Aviso de pendente"
                            color="#D80000"
                            as={RiErrorWarningLine}
                            boxSize="20px"
                          />
                        )}
                      </Flex>
                    </ItemMenu>
                  </Permission>
                  {roleKeycloack &&
                    !roleKeycloack.includes(
                      criancaFunc.visualizarTudoDefensoria
                    ) && (
                      <ItemMenu
                        height="40px"
                        icon={<Icon boxSize="20px" as={MdOutlineFilePresent} />}
                        onClick={() => {
                          handleMenuItemClick(
                            "/crianca/visualizar-anexos/" + id
                          );
                        }}
                      >
                        Anexos
                      </ItemMenu>
                    )}
                </>
              ) : (
                ""
              )}
            </MenuList>
          </Menu>
        </Flex>
        {/*Barra lateral*/}
        <Flex
          flexDir="column"
          bgColor="#FFF"
          px="10px"
          py="20px"
          borderRadius="16px"
          minW={"214.094px"}
          w={{ base: "100%", xl: "20%" }}
        >
          {data ? (
            <>
              <Flex
                flexDir="column"
                alignItems="center"
                justifyContent="center"
              >
                {imagem ? (
                  <Image
                    borderRadius="full"
                    boxSize="135px"
                    fit="cover"
                    src={imagem + "?" + Date.now()}
                    onError={() => setImagem("")}
                  />
                ) : (
                  <Box boxSize="135px" bgColor="#C4C4C4" borderRadius="full" />
                )}
                <Text
                  mt="10px"
                  color="#000"
                  fontWeight={700}
                  fontSize="16px"
                  lineHeight="21.6px"
                  textAlign={"center"}
                  w={"100%"}
                >
                  {data?.nome} {data.nomeSocial ? " / " + data.nomeSocial : ""}
                </Text>
              </Flex>
              <Permission
                roleKeycloack={roleKeycloack}
                func={criancaFunc.imprimir}
              >
                <Flex justifyContent={"center"} mt={4} px={{ base: 2, xl: 7 }}>
                  <PrintButtonCrianca idCrianca={id} />
                </Flex>
              </Permission>
              <Flex flexDir="column" display={{ base: "none", xl: "flex" }}>
                <Information
                  title="Data da Foto:"
                  information={
                    data.dataFoto ? format(data.dataFoto, "dd/MM/yyyy") : ""
                  }
                  mt={30}
                />
                <Information
                  title="Situação:"
                  information={
                    primeiraMovimentacao
                      ? primeiraMovimentacao.motivoSituacao &&
                        primeiraMovimentacao.motivoSituacao.tipoSituacao
                          .descricao === "Acolhido"
                        ? "Acolhido"
                        : primeiraMovimentacao.motivoSituacao &&
                          primeiraMovimentacao.motivoSituacao.tipoSituacao
                            .descricao === "Desligado"
                        ? "Desligado"
                        : !primeiraMovimentacao.motivoSituacao &&
                          !primeiraMovimentacao.movimentoMovimentacao
                        ? "Pendente"
                        : !primeiraMovimentacao.motivoSituacao &&
                          primeiraMovimentacao?.movimentoMovimentacao
                            ?.tipoSituacaoMovimentacao?.descricao
                        ? primeiraMovimentacao?.movimentoMovimentacao
                            ?.tipoSituacaoMovimentacao?.descricao
                        : ""
                      : ""
                  }
                />
                <Information
                  title="Serviço de Acolhimento:"
                  information={
                    (data.movimentacoes[data?.movimentacoes?.length - 1]
                      ?.motivoSituacao?.riscoVida === "S" &&
                      !permissaoServico) ||
                    (!permissaoServico &&
                      (data?.movimentacoes[data?.movimentacoes?.length - 1]
                        ?.movimentoMovimentacao?.id === 2 ||
                        data?.movimentacoes[data?.movimentacoes?.length - 1]
                          ?.movimentoMovimentacao?.id === 1) &&
                      temRiscoVidaInfo) ? (
                      ""
                    ) : data.servicoAcolhimento ? (
                      <Link onClick={() => onOpen()}>
                        {data.servicoAcolhimento.nomeFantasia}
                      </Link>
                    ) : (
                      ""
                    )
                  }
                />
                <Information
                  title="Data de Nascimento:"
                  information={
                    data.dataNascimento
                      ? format(data.dataNascimento, "dd/MM/yyyy") +
                        (data.dataNascimentoEstimada === "S"
                          ? " (Estimada)"
                          : "")
                      : ""
                  }
                />
                <Information
                  title="Gênero:"
                  information={data.genero ? data.genero.genero : ""}
                />
                <Information
                  title="Raça/Cor:"
                  information={data.raca ? data.raca.raca : ""}
                />
                <Information
                  title="Nacionalidade:"
                  information={
                    data.nacionalidade ? data.nacionalidade.nacionalidade : ""
                  }
                />
                <Information
                  title="Naturalidade:"
                  information={data.naturalidade ? data.naturalidade.nome : ""}
                />
                <Information
                  title="Criança é Registrada?"
                  information={
                    !!documentacao
                      ? documentacao?.registrada?.trim() === "S"
                        ? "Sim"
                        : documentacao?.registrada?.trim() === "N"
                        ? "Não"
                        : "Sem Informação"
                      : "Sem Informação"
                  }
                />
                <Information
                  title="Filiação:"
                  information={data.filiacoes
                    .sort((a, b) =>
                      a?.tipoFiliacao?.localeCompare(b?.tipoFiliacao)
                    )
                    .map((info, index) => (
                      <p key={index}>
                        <Box as="span" fontWeight={700}>
                          {info.tipoFiliacao}
                          {": "}
                        </Box>
                        {info.filiacao.nome}{" "}
                        {info.filiacao.falecido === "S"
                          ? "(Falecido)"
                          : info.filiacao.idCriancaFiliacaoAcolhido
                          ? "(Acolhido(a))"
                          : ""}
                      </p>
                    ))}
                />
                <Information
                  title="Possui Irmãos?"
                  information={data.possuiIrmao ? "Sim" : "Não"}
                />
                <Information
                  title="Data de Criação:"
                  information={
                    data.dataCadastro
                      ? format(data.dataCadastro, "dd/MM/yyyy")
                      : ""
                  }
                />
                <Information
                  title="Data da Última Atualização:"
                  information={
                    data.ultimaAtualizacao
                      ? format(data.ultimaAtualizacao, "dd/MM/yyyy")
                      : ""
                  }
                />
              </Flex>
            </>
          ) : (
            <LoadingSpinner />
          )}
        </Flex>

        {/*menu completo*/}
        <Flex flexDir="column" ml={{ base: "0px", xl: "15px" }} flex={1}>
          {data ? (
            <>
              <Grid
                templateColumns="repeat(6, 1fr)"
                gap={4}
                p={2}
                h={"auto"}
                alignItems={"center"}
                borderRadius="10px"
                bgColor="#FFF"
                display={{ base: "none", xl: "grid" }}
              >
                <GridItem>
                  <MenuItem
                    title="Dados Principais"
                    icon={<Icon boxSize="20px" as={HiOutlineClipboardList} />}
                    isActive={pagina === "Visualizar" || pagina === "Editar"}
                    onClick={() => handleMenuItemClick("/crianca/" + id)}
                  />
                </GridItem>

                {visualizarDados ? (
                  <>
                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={vrCriancaFunc.documentacaoVisualizar}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <GridItem>
                        <MenuItem
                          title="Documentação"
                          icon={<Icon boxSize="20px" as={IoDocumentsOutline} />}
                          isActive={pagina.includes("Documentacao")}
                          onClick={() =>
                            handleMenuItemClick(
                              "/crianca/visualizar-documentacao/" + id
                            )
                          }
                          pendente={
                            pendentes ? pendentes.documentacao === 0 : false
                          }
                        />
                      </GridItem>
                    </Permission>

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={vrCriancaFunc.movimentoVisualizar}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <GridItem>
                        <MenuItem
                          title="Histórico"
                          icon={<Icon boxSize="20px" as={GrDocumentTime} />}
                          isActive={pagina.includes("Movimentacao")}
                          onClick={() =>
                            handleMenuItemClick(
                              "/crianca/visualizar-movimentacao/" + id
                            )
                          }
                          pendente={
                            pendentes ? pendentes.movimentacao === 0 : false
                          }
                        />
                      </GridItem>
                    </Permission>

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={referenciaFunc.referenciaVisualizar}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <GridItem>
                        <MenuItem
                          title="Referência Familiar e Comunitária"
                          icon={
                            <Icon
                              boxSize="20px"
                              style={{ transform: "rotate(180deg)" }}
                              as={GiFamilyTree}
                            />
                          }
                          isActive={pagina.includes("Referencia Familiar")}
                          onClick={() =>
                            handleMenuItemClick(
                              "/crianca/visualizar-referencia-familiar/" + id
                            )
                          }
                          pendente={
                            pendentes ? pendentes.grupoFraterno === 0 : false
                          }
                        />
                      </GridItem>
                    </Permission>

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={criancaFunc.visualizarSaude}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <GridItem>
                        <MenuItem
                          title="Saúde"
                          icon={<Icon boxSize="20px" as={BsHeartPulse} />}
                          isActive={pagina.includes("Saude")}
                          onClick={() =>
                            handleMenuItemClick(
                              "/crianca/visualizar-saude/" + id
                            )
                          }
                          pendente={pendentes ? pendentes.saude === 0 : false}
                        />
                      </GridItem>
                    </Permission>

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={criancaFunc.visualizarEducacao}
                      user={user}
                      id={idPJ}
                      visualizar={true}
                    >
                      <GridItem>
                        <MenuItem
                          title="Educação"
                          icon={<Icon boxSize="20px" as={PiBookBookmarkBold} />}
                          isActive={pagina.includes("Educacao")}
                          onClick={() =>
                            handleMenuItemClick(
                              "/crianca/visualizar-educacao/" + id
                            )
                          }
                          pendente={
                            pendentes ? pendentes.educacao === 0 : false
                          }
                        />
                      </GridItem>
                    </Permission>
                  </>
                ) : (
                  ""
                )}
              </Grid>
              {visualizarDados ? (
                <Grid
                  mt={4}
                  templateColumns="repeat(6, 1fr)"
                  gap={4}
                  h={"auto"}
                  alignItems={"center"}
                  p={2}
                  borderRadius="10px"
                  bgColor="#FFF"
                  display={{ base: "none", xl: "grid" }}
                >
                  {diferencaAnos >= 16 && (
                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={criancaFunc.visualizarProfissionalizacao}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <GridItem>
                        <MenuItem
                          title="Profissionalização"
                          icon={<Icon boxSize="20px" as={RiSuitcaseLine} />}
                          isActive={pagina.includes("Profissionalizacao")}
                          onClick={() =>
                            handleMenuItemClick(
                              "/crianca/visualizar-profissionalizacao/" + id
                            )
                          }
                          pendente={
                            pendentes
                              ? pendentes.profissionalizacao === 0
                              : false
                          }
                        />
                      </GridItem>
                    </Permission>
                  )}
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={ocorrenciasFunc.visualizar}
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    <GridItem>
                      <MenuItem
                        title="Ocorrências"
                        icon={<Icon boxSize="20px" as={FiFileText} />}
                        isActive={pagina.includes("Ocorrencias")}
                        onClick={() =>
                          handleMenuItemClick(
                            "/crianca/visualizar-ocorrencias/" + id
                          )
                        }
                        pendente={
                          pendentes ? pendentes.ocorrencias === 0 : false
                        }
                      />
                    </GridItem>
                  </Permission>

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={vrCriancaFunc.visitaCriancaVisualizar}
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    <GridItem>
                      <MenuItem
                        title="Visitas"
                        icon={<Icon boxSize="20px" as={FaArrowsDownToPeople} />}
                        isActive={pagina.includes("Visitas")}
                        onClick={() => {
                          handleMenuItemClick(
                            "/crianca/visualizar-visitas/" + id
                          );
                        }}
                        pendente={pendentes ? pendentes.visita === 0 : false}
                      />
                    </GridItem>
                  </Permission>

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={criancaFunc.visualizarJuridica}
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    <GridItem>
                      <MenuItem
                        title="Situação Jurídica"
                        icon={<Icon boxSize="20px" as={TbGavel} />}
                        isActive={pagina.includes("Juridica")}
                        onClick={() => {
                          handleMenuItemClick(
                            "/crianca/visualizar-situacao-juridica/" + id
                          );
                        }}
                        pendente={
                          pendentes ? pendentes.situacaoJuridica === 0 : false
                        }
                      />
                    </GridItem>
                  </Permission>

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={criancaFunc.apadrinhamentoVisualizar}
                    id={idPJ}
                    user={user}
                    visualizar={true}
                  >
                    <GridItem>
                      <MenuItem
                        title="Programa de Apadrinhamento"
                        icon={<Icon boxSize="20px" as={LoveIcon} />}
                        isActive={pagina.includes("Apadrinhamento")}
                        onClick={() =>
                          handleMenuItemClick(
                            "/crianca/visualizar-apadrinhamento/" + id
                          )
                        }
                        pendente={
                          pendentes ? pendentes?.apadrinhamento === 0 : false
                        }
                      />
                    </GridItem>
                  </Permission>

                  {roleKeycloack &&
                    !roleKeycloack.includes(
                      criancaFunc.visualizarTudoDefensoria
                    ) && (
                      <GridItem>
                        <MenuItem
                          title="Anexos"
                          icon={
                            <Icon boxSize="20px" as={MdOutlineFilePresent} />
                          }
                          isActive={pagina.includes("Anexos")}
                          onClick={() => {
                            handleMenuItemClick(
                              "/crianca/visualizar-anexos/" + id
                            );
                          }}
                          pendente={pendentes ? pendentes.anexos === 0 : false}
                        />
                      </GridItem>
                    )}
                </Grid>
              ) : (
                ""
              )}
            </>
          ) : (
            <Flex
              justifyContent={"center"}
              alignItems={"center"}
              borderRadius="10px"
              bgColor="#FFF"
              p={3}
            >
              <LoadingSpinner />
            </Flex>
          )}
          {children}
        </Flex>
      </Flex>
      <ServicoPreviewModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        idSA={data?.servicoAcolhimento?.id}
      />
    </Flex>
  );
};
